<template>
<div><Topnav/>
<div class="content">
  <div class="jumbotron text-center">
    <h2>Shopping Bot</h2>
    <hr class="bg-dark"/>
    <p>Helps in taking orders from customers</p>
  </div>


  <div class="container">
    <div class="row">
      <div class="col-md-2">

      </div>

      <div class="col-md-8 col-xs-12">
      <h4 class="text-center">Coming Soon</h4>

      </div>

      <div class="col-md-2">

      </div>
    </div>


  </div>


</div>

</div>
</template>


<script type="text/javascript">
import Topnav from "@/components/Topnav.vue";

export default {
  name: "ShoppingBot",
  components:{
    Topnav
  },
  data: function() {
    return {

    }
  },
  methods: {
  }
}
</script>
